export const POINTER_STATUS = [
  { value: "HIGH", name: "parcels_list__map_legend_risk_level_high" },
  { value: "MEDIUM", name: "parcels_list__map_legend_risk_level_medium" },
  { value: "LOW", name: "parcels_list__map_legend_risk_level_low" },
  { value: "VIGILANCE", name: "parcels_list__map_legend_risk_level_vigilance" },
  { value: "NONE", name: "parcels_list__map_legend_risk_level_none" },
];
